<template>
	<div class="addPosition">
		<el-container>
			<el-header class="management_header">
				<div class="nidrlogo">
					<img src="../../image/zsdb_logo.png" />
				</div>
				<div class="accoutInfo">
					<span class="headerText">尊敬的管理员{{showID}}，您好！</span>
					<span class="divider">|</span>
					<el-link type="primary" class="headerText" @click="addControl()">+新增管理员</el-link>
					<span class="divider">|</span>
					<el-link type="primary" @click="exit()" class="headerText">退出</el-link>
				</div>
			</el-header>
			<el-container>
				<el-aside class="management_aside">
					<el-menu default-active="3-2" class="personalmenu" background-color="#545c64" text-color="#fff"
						active-text-color="#ffd04b">
						<el-menu-item index="1" @click="gotoadd()">
							<span class="menuText" slot="title">新增岗位</span>
						</el-menu-item>
						<el-menu-item index="2" @click="gotoreset()">
							<span class="menuText" slot="title">查询/修改岗位信息</span>
						</el-menu-item>
						<el-submenu index="3">
							<template slot="title">
								<span class="menuText">查看简历</span>
							</template>
							<el-menu-item-group>
								<el-menu-item index="3-1" @click="gotolookupresumeByName()">按人名查找</el-menu-item>
								<el-menu-item index="3-2" @click="gotolookupresume()">按时间、岗位查找</el-menu-item>
							</el-menu-item-group>
						</el-submenu>
						<el-menu-item index="4" @click="gotorecruitInfoService()">
							<span class="menuText" slot="title">招聘公告维护</span>
						</el-menu-item>
					</el-menu>
				</el-aside>
				<el-main class="management_body">
					<addControl v-show="addControlDialog" v-on:addAdmingAccount='addAdmingAccount'></addControl>
					<div class="lookup_area">
						<div class="lokkup_title">
							<span>简历查询</span>
						</div>
						<div class="lookup_body">
							<div class="select_position">
								<el-select v-model="value" placeholder="请选择" class="select_area">
									<el-option-group v-for="group in options" :key="group.label" :label="group.label">
										<el-option v-for="item in group.options" :key="item.value" :label="item.label"
											:value="item.value">
											<span style="float: left">{{ item.label }}</span>
											<span
												style="float: right; color: #8492a6; font-size: 12px">{{ item.value }}</span>
										</el-option>
									</el-option-group>
								</el-select>
							</div>
							<div class="time_select">
								<el-date-picker v-model="selectTime" type="daterange" range-separator="至"
									start-placeholder="开始日期" end-placeholder="结束日期" :picker-options="pickerOptions"
									format="yyyy 年 MM 月 dd 日" value-format="timestamp">
								</el-date-picker>
							</div>
							<div class="resumeStatus_select">
								<el-radio v-model="resumeStatus" :label="0">未完成投递</el-radio>
								<el-radio v-model="resumeStatus" :label="1">已完成投递</el-radio>
							</div>
							<div class="select_button">
								<el-button @click="selectResume()">搜索</el-button>
							</div>
						</div>
						<div class="lookup_info">
							<el-table :data="lookupresume" style="width: 100%" @selection-change="selectionChange"
								v-infinite-scroll="load">
								<el-table-column type="selection" width="55">
								</el-table-column>
								<el-table-column prop="userID" label="用户ID">
								</el-table-column>
								<el-table-column prop="name" label="姓名">
								</el-table-column>
								<el-table-column prop="age" label="年龄">
								</el-table-column>
								<el-table-column prop="degree" label="学历">
								</el-table-column>
								<el-table-column prop="first.positionName" label="第一志愿">
								</el-table-column>
								<el-table-column prop="second.positionName" label="第二志愿">
								</el-table-column>
								<el-table-column fixed="right" label="操作" width="150">
									<template slot-scope="scope">
										<el-button @click="cheakResume(scope.row)" type="text" size="small">查看
										</el-button>
										<el-button @click="downloadWord(scope.row)" type="text" size="small">下载附件
										</el-button>
										<el-button @click="unlockResume(scope.row)" type="text" size="small">解锁
										</el-button>
									</template>
								</el-table-column>
								<el-table-column fixed="right" prop="updateTime" label="提交时间" width="150">
								</el-table-column>
							</el-table>
						</div>
						<div class="push_excel">
							<el-button type="success" class="excel_button" @click="pushExcel()">导出为Excel</el-button>
							<el-button type="success" class="excel_button" @click="pushPack()">打包导出</el-button>
						</div>
					</div>
					<el-dialog class="resumeDialogCheak" :visible.sync="dialogPersonalResume">
						<div ref="pdf" class="push_divtopdf">
							<div class="dialogTitle">
								<span class="titleStyle">{{cheakResumeArray.name}}的简历</span>
							</div>
							<div class="dialog_info">
								<el-divider style="margin-top: 5px;" content-position="left">基本信息</el-divider>
								<div style="display: flex;">
									<div>
										<div class="info_area">
											<span style="font-size: 14px; color: blue;">姓名：</span>
											<span class="infoStyle">{{cheakResumeArray.name}}</span>
										</div>
										<div class="info_area">
											<span style="font-size: 14px; color: blue;">性别：</span>
											<span class="infoStyle">{{cheakResumeArray.gender}}</span>
										</div>
										<div class="info_area">
											<span style="font-size: 14px; color: blue;">出生日期：</span>
											<span class="infoStyle">{{cheakResumeArray.birthday}}</span>
										</div>
										<div class="info_area">
											<span style="font-size: 14px; color: blue;">年龄：</span>
											<span class="infoStyle">{{cheakResumeArray.age}}</span>
										</div>
										<div class="info_area">
											<span style="font-size: 14px; color: blue;">身高：</span>
											<span class="infoStyle">{{cheakResumeArray.height}}</span>
										</div>
										<div class="info_area">
											<span style="font-size: 14px; color: blue;">体重：</span>
											<span class="infoStyle">{{cheakResumeArray.weight}}</span>
										</div>
										<div class="info_area">
											<span style="font-size: 14px; color: blue;">邮箱：</span>
											<span class="infoStyle">{{cheakResumeArray.mail}}</span>
										</div>
										<div class="info_area">
											<span style="font-size: 14px; color: blue;">手机号：</span>
											<span class="infoStyle">{{cheakResumeArray.phoneNumber}}</span>
										</div>
										<div class="info_area">
											<span style="font-size: 14px; color: blue;">证件类型：</span>
											<span class="infoStyle">{{cheakResumeArray.documentsType}}</span>
										</div>
										<div class="info_area">
											<span style="font-size: 14px; color: blue;">证件号码：</span>
											<span class="infoStyle">{{cheakResumeArray.documentsNumber}}</span>
										</div>
										<div class="info_area">
											<span style="font-size: 14px; color: blue;">最高学历：</span>
											<span class="infoStyle">{{cheakResumeArray.degree}}</span>
										</div>
										<div class="info_area">
											<span style="font-size: 14px; color: blue;">学习形式：</span>
											<span class="infoStyle">{{cheakResumeArray.degreeMode}}</span>
										</div>
										<div class="info_area">
											<span style="font-size: 14px; color: blue;">毕业时间：</span>
											<span class="infoStyle">{{cheakResumeArray.graduationTime}}</span>
										</div>
										<!-- <div class="info_area">
											<span style="font-size: 14px; color: blue;">海外留学经历：</span>
											<span class="infoStyle">{{cheakResumeArray.studyAbroad}}</span>
										</div>
										<div class="info_area">
											<span style="font-size: 14px; color: blue;">应届/往届：</span>
											<span class="infoStyle">{{cheakResumeArray.freshPast}}</span>
										</div>
										<div class="info_area">
											<span style="font-size: 14px; color: blue;">工作年限：</span>
											<span class="infoStyle">{{cheakResumeArray.workDuration}}</span>
										</div>
										<div class="info_area">
											<span style="font-size: 14px; color: blue;">参加工作时间：</span>
											<span class="infoStyle">{{cheakResumeArray.workStartTime}}</span>
										</div> -->
										<div class="info_area">
											<span style="font-size: 14px; color: blue;">现居住地：</span>
											<span class="infoStyle">{{cheakResumeArray.currentResidence}}</span>
										</div>
										<div class="info_area">
											<span style="font-size: 14px; color: blue;">政治面貌：</span>
											<span class="infoStyle">{{cheakResumeArray.politicalLandscape}}</span>
										</div>
										<div class="info_area">
											<span style="font-size: 14px; color: blue;">民族：</span>
											<span class="infoStyle">{{cheakResumeArray.ethnicGroup}}</span>
										</div>
										<div class="info_area">
											<span style="font-size: 14px; color: blue;">籍贯：</span>
											<span class="infoStyle">{{cheakResumeArray.origin}}</span>
										</div>
										<div class="info_area">
											<span style="font-size: 14px; color: blue;">婚姻状况：</span>
											<span class="infoStyle">{{cheakResumeArray.maritalStatus}}</span>
										</div>
										<!-- <div class="info_area">
											<span style="font-size: 14px; color: blue;">有无子女：</span>
											<span class="infoStyle">{{cheakResumeArray.childrenStatus}}</span>
										</div> -->
										<!-- 										<div class="info_area">
											<span style="font-size: 14px; color: blue;">紧急联系人：</span>
											<span class="infoStyle">{{cheakResumeArray.emergencyContacts}}</span>
										</div> -->
										<div class="info_area">
											<span style="font-size: 14px; color: blue;">紧急联系人联系方式：</span>
											<span
												class="infoStyle">{{cheakResumeArray.emergencyContactsPhoneNumber}}</span>
										</div>
										<div class="info_area">
											<span style="font-size: 14px; color: blue;">英语等级：</span>
											<span class="infoStyle">{{cheakResumeArray.levelOfEnglish}}</span>
										</div>
										<div class="info_area">
											<span style="font-size: 14px; color: blue;">英语等级成绩：</span>
											<span class="infoStyle">{{cheakResumeArray.scoresOfEnglish}}</span>
										</div>
									</div>
									<div class="img_area">
										<el-image style="width: 140px; height: 200px" :src="imageLink"></el-image>
									</div>
								</div>
								<el-divider content-position="left">其他信息</el-divider>
								<div class="info_area1" style="display: flex;">
									<span style="font-size: 14px; color: blue;">兴趣爱好：</span>
									<div class="textArea_show" v-if="cheakResumeArray.additionalInformation">
										<span class="infoStyle"
											style="white-space: pre-wrap;">{{cheakResumeArray.additionalInformation.hobby}}</span>
									</div>
								</div>
								<div class="info_area1" style="display: flex;">
									<span style="font-size: 14px; color: blue;">特长：</span>
									<div class="textArea_show" v-if="cheakResumeArray.additionalInformation">
										<span class="infoStyle"
											style="white-space: pre-wrap;">{{cheakResumeArray.additionalInformation.specialty}}</span>
									</div>
								</div>
								<!-- <div class="info_area1" style="display: flex;">
									<span style="font-size: 14px; color: blue;">其他：</span>
									<div class="textArea_show" v-if="cheakResumeArray.additionalInformation">
										<span class="infoStyle"
											style="white-space: pre-wrap;">{{cheakResumeArray.additionalInformation.otherInfo}}</span>
									</div>
								</div> -->
								<div class="info_area" style="display: flex;">
									<span style="font-size: 14px; color: blue;">自我评价：</span>
									<div class="textArea_show">
										<span class="infoStyle"
											style="white-space: pre-wrap;">{{cheakResumeArray.selfEvaluation}}</span>
									</div>
								</div>
								<el-divider content-position="left">教育经历</el-divider>
								<div v-for="(item,index) in cheakResumeArray.educationalBackground"
									class="Descriptions">
									<el-descriptions :key="index" :educationalBackground="item" direction="vertical"
										:column="4" border>
										<el-descriptions-item label="学校名称">{{item.name}}</el-descriptions-item>
										<el-descriptions-item label="起止时间">{{item.startTime}} 至 {{item.endTime}}
										</el-descriptions-item>
										<el-descriptions-item label="专业名称">{{item.majorName}}</el-descriptions-item>
										<el-descriptions-item label="学历">{{item.degree}}</el-descriptions-item>
										<el-descriptions-item label="专业排名">{{item.professionalRanking}}
										</el-descriptions-item>
										<el-descriptions-item label="专业课程">{{item.professionalCourses}}
										</el-descriptions-item>
									</el-descriptions>
								</div>

								<el-divider content-position="left">实习经历</el-divider>
								<div v-for="(item,index) in cheakResumeArray.internshipExperience" class="Descriptions">
									<el-descriptions :key="index" :internshipExperience="item" direction="vertical"
										:column="4" border>
										<el-descriptions-item label="公司">{{item.companyName}}</el-descriptions-item>
										<el-descriptions-item label="职位">{{item.position}}</el-descriptions-item>
										<el-descriptions-item label="起止时间">{{item.startTime}} 至 {{item.endTime}}
										</el-descriptions-item>
										<el-descriptions-item label="实习内容描述">{{item.content}}</el-descriptions-item>
									</el-descriptions>
								</div>

								<el-divider content-position="left">工作经历</el-divider>
								<div v-for="(item,index) in cheakResumeArray.workExperience" class="Descriptions">
									<el-descriptions :key="index" :workExperience="item" direction="vertical"
										:column="4" border>
										<el-descriptions-item label="公司">{{item.companyName}}</el-descriptions-item>
										<el-descriptions-item label="职位">{{item.position}}</el-descriptions-item>
										<el-descriptions-item label="起止时间">{{item.startTime}} 至 {{item.endTime}}
										</el-descriptions-item>
										<el-descriptions-item label="工作内容描述">{{item.content}}</el-descriptions-item>
									</el-descriptions>
								</div>

								<el-divider content-position="left">项目经历</el-divider>
								<div v-for="(item,index) in cheakResumeArray.projectExperience" class="Descriptions">
									<el-descriptions :key="index" :projectExperience="item" direction="vertical"
										:column="4" border>
										<el-descriptions-item label="项目名称">{{item.projectName}}</el-descriptions-item>
										<el-descriptions-item label="项目角色">{{item.position}}</el-descriptions-item>
										<el-descriptions-item label="起止时间">{{item.startTime}} 至 {{item.endTime}}
										</el-descriptions-item>
										<el-descriptions-item label="项目描述">{{item.description}}</el-descriptions-item>
									</el-descriptions>
								</div>

								<el-divider content-position="left">获奖情况</el-divider>
								<div v-for="(item,index) in cheakResumeArray.awards" class="Descriptions">
									<el-descriptions :key="index" :awards="item" direction="vertical" :column="4"
										border>
										<el-descriptions-item label="奖项类型">{{item.awardType}}</el-descriptions-item>
										<el-descriptions-item label="奖项名称">{{item.name}}</el-descriptions-item>
										<el-descriptions-item label="获奖时间">{{item.time}}</el-descriptions-item>
										<el-descriptions-item label="奖项描述">{{item.description}}</el-descriptions-item>
									</el-descriptions>
								</div>

								<el-divider content-position="left">论文著作情况</el-divider>
								<div v-for="(item,index) in cheakResumeArray.papersMonographs" class="Descriptions">
									<el-descriptions :key="index" :papersMonographs="item" direction="vertical"
										:column="4" border>
										<el-descriptions-item label="名称">{{item.name}}</el-descriptions-item>
										<el-descriptions-item label="发布时间">{{item.time}}</el-descriptions-item>
										<el-descriptions-item label="发布期刊">{{item.periodical}}</el-descriptions-item>
										<el-descriptions-item label="作者顺序">{{item.authorOrder}}</el-descriptions-item>
										<el-descriptions-item label="论文著作详情"><span
												style="white-space: pre-wrap;">{{item.annualPeriod}}</span>
										</el-descriptions-item>
									</el-descriptions>
								</div>

								<el-divider content-position="left">资格证书</el-divider>
								<div v-for="(item,index) in cheakResumeArray.certificate" class="Descriptions">
									<el-descriptions :key="index" :certificate="item" direction="vertical" :column="4"
										border>
										<el-descriptions-item label="证书种类">{{item.type}}</el-descriptions-item>
										<el-descriptions-item label="证书名称">{{item.name}}</el-descriptions-item>
										<el-descriptions-item label="获得时间">{{item.time}}</el-descriptions-item>
										<el-descriptions-item label="证书描述">{{item.description}}</el-descriptions-item>
									</el-descriptions>
								</div>

								<el-divider content-position="left">语言能力</el-divider>
								<div v-for="(item,index) in cheakResumeArray.languageSkills" class="Descriptions">
									<el-descriptions :key="index" :languageSkills="item" direction="vertical"
										:column="4" border>
										<el-descriptions-item label="语言">{{item.languageType}}</el-descriptions-item>
										<el-descriptions-item label="精通程度">{{item.mastery}}</el-descriptions-item>
									</el-descriptions>
								</div>

								<el-divider content-position="left">技能</el-divider>
								<div v-for="(item,index) in cheakResumeArray.certificate" class="Descriptions">
									<el-descriptions :key="index" :certificate="item" direction="vertical" :column="4"
										border>
										<el-descriptions-item label="技能名称">{{item.name}}</el-descriptions-item>
										<el-descriptions-item label="掌握程度">{{item.mastery}}</el-descriptions-item>
									</el-descriptions>
								</div>

								<el-divider content-position="left">亲属在水利系统从业情况</el-divider>
								<div v-for="(item,index) in cheakResumeArray.waterSystemRelativesInfo"
									class="Descriptions">
									<div>
										<el-divider>亲属情况{{index+1}}</el-divider>
										<div class="info_area">
											<span style="font-size: 14px; color: blue;">姓名：</span>
											<span class="infoStyle">{{item.name}}</span>
										</div>
										<div class="info_area">
											<span style="font-size: 14px; color: blue;">与本人关系：</span>
											<span class="infoStyle">{{item.relationship}}</span>
										</div>
										<div class="info_area">
											<span style="font-size: 14px; color: blue;">工作单位：</span>
											<span class="infoStyle">{{item.companyName}}</span>
										</div>
										<div class="info_area">
											<span style="font-size: 14px; color: blue;">职务：</span>
											<span class="infoStyle">{{item.position}}</span>
										</div>
										<div class="info_area">
											<span style="font-size: 14px; color: blue;">联系电话：</span>
											<span class="infoStyle">{{item.phoneNumber}}</span>
										</div>
									</div>
								</div>

								<el-divider content-position="left">家庭主要成员情况</el-divider>
								<div v-for="(item,index) in cheakResumeArray.familySituation" class="Descriptions">
									<el-descriptions :key="index" :familySituation="item" direction="vertical"
										:column="4" border>
										<el-descriptions-item label="姓名">{{item.name}}</el-descriptions-item>
										<el-descriptions-item label="与本人关系">{{item.relationship}}</el-descriptions-item>
										<el-descriptions-item label="工作单位">{{item.companyName}}</el-descriptions-item>
										<el-descriptions-item label="职务">{{item.position}}</el-descriptions-item>
										<el-descriptions-item label="联系电话">{{item.phoneNumber}}</el-descriptions-item>
									</el-descriptions>
								</div>

								<el-divider content-position="left">声明</el-divider>
								<div style="display: block;">
									<div style="display: flex;" class="info_area">
										<span
											style="font-size: 14px; color: blue;">是否已经与其他单位签有工作合同或协议，或在其他单位工作且尚未办清离职手续:
										</span>
										<span>{{cheakResumeArray.otherWorkContractsStatus}}</span>
									</div>
									<div style="display: flex;" class="info_area">
										<span style="font-size: 14px; color: blue;">是否曾被其他单位惩诫、开除、辞退:
										</span>
										<span>{{cheakResumeArray.workPunishmentsStatus}}</span>
									</div>
									<div style="display: flex;" class="info_area">
										<span style="font-size: 14px; color: blue;">是否有违法、违纪或其他不良行为:
										</span>
										<span>{{cheakResumeArray.illegalRecordStatus}}</span>
									</div>
								</div>

							</div>
							<div class="push_PDF">
								<el-button class="push_button" type="primary" @click="pushPDF()">另存为PDF</el-button>
								<el-button class="push_button" type="primary" @click="pushWord()">另存为word</el-button>
							</div>
						</div>
					</el-dialog>
				</el-main>
			</el-container>
		</el-container>
		<div class="footer">
			<div class="container">
				<p>&copy 2022 Inc. All Rights Reserved. 中水东北勘测设计研究有限责任公司 版权所有 吉ICP备2022003947号-1
					技术支持：中水东北勘测设计研究有限责任公司数字与智慧工程院
					<br />吉公网安备 22010402001082号
				</p>
			</div>
		</div>
	</div>
</template>

<script>
	import addControl from "../../components/addControl.vue"
	import {
		loginstatus,
		Logout,
		addAdminUser,
		queryPositionBackend,
		queryResumeByPosIDAndTime,
		queryResumeByTime,
		exportExcelByUserList,
		exportResumAsPDFByUserId,
		downloadPDF,
		exportResumAsDocxByUserId,
		unLockResumeByUserId,
		exportPkgByUserList,
	} from '../../api/user.js';
	export default {
		components: {
			addControl,
		},
		data() {
			return {
				imageLink: '',
				dialogPersonalResume: false,
				lookupresume: [],
				resumeStatus: 1,
				pickerOptions: {
					disabledDate(time) {
						return time.getTime() > Date.now();
					},
				},
				options: [{
					label: '校招岗位',
					options: [],
				}, {
					label: '社招岗位',
					options: [],
				}, {
					label: '实习生岗位',
					options: [],
				}],
				value: '',
				addControlDialog: false,
				userID: '',
				showID: '',
				selectTime: '',
				exportExcel: [],
				cheakResumeArray: {},
			};
		},
		mounted() {
			loginstatus().then((res) => {
				if (res.code == 300) {
					let str = res.data;
					this.showID = str.substring(0, 3) + '****' + str.substring(7, 11);
					this.userID = res.datadata
				} else {
					this.$message({
						message: '您不具有管理员权限！',
						type: 'error'
					});
					this.$router.push('/')
				}
			});
			queryPositionBackend().then((res) => {
				var i = 0;
				if (res.code == 200) {
					for (i; i < res.data.length; i++) {
						if (res.data[i].type == 0) {
							var campusArr = {
								value: '',
								label: '',
							}
							campusArr.value = res.data[i].positionID
							campusArr.label = res.data[i].positionName
							this.options[0].options.push(campusArr)
						} else if (res.data[i].type == 1) {
							var societyArr = {
								value: '',
								label: '',
							}
							societyArr.value = res.data[i].positionID
							societyArr.label = res.data[i].positionName
							this.options[1].options.push(societyArr)
						} else if (res.data[i].type == 2) {
							var internArr = {
								value: '',
								label: '',
							}
							internArr.value = res.data[i].positionID
							internArr.label = res.data[i].positionName
							this.options[2].options.push(internArr)
						}
					}
				} else {
					this.$message({
						message: '数据请求失败！',
						type: 'error'
					});
				}
			});
		},
		methods: {
			unlockResume(row) {
				unLockResumeByUserId({
					userID: row.userID,
				}).then((res) => {
					this.$message({
						message: '该用户简历解锁成功！',
						type: 'success'
					});
				})
			},
			load() {
				this.count += 2
			},
			pushWord() {
				exportResumAsDocxByUserId({
					userID: this.cheakResumeArray.userID,
				}).then((res) => {
					var baseUrl;
					baseUrl = res.data;
					let url = baseUrl
					const a = document.createElement('a')
					a.href = url
					// a.download = '校园招聘报名登记表.docx' 
					a.style.display = 'none'
					document.body.appendChild(a)
					a.click() // 点击下载
					document.body.removeChild(a) // 下载完成移除元素
				})
			},
			pushPDF() {
				exportResumAsPDFByUserId({
					userID: this.cheakResumeArray.userID,
				}).then((res) => {
					if (res.code == 200) {
						var baseUrl;
						baseUrl = res.data
						window.open(baseUrl, '_blank')
					} else {
						this.$message({
							message: 'PDF请求失败！',
							type: 'error'
						});
					}
				})
			},
			pushExcel() {
				var list = []
				var i = 0
				for (i; i < this.exportExcel.length; i++) {
					list[i] = this.exportExcel[i].userID
				}
				exportExcelByUserList({
					listData: list
				}).then((res) => {
					if (res.code == 200) {
						console.log(res)
						var baseUrl;
						baseUrl = res.data;
						let url = baseUrl
						const a = document.createElement('a')
						a.href = url
						// a.download = '校园招聘报名登记表.docx' 
						a.style.display = 'none'
						document.body.appendChild(a)
						a.click() // 点击下载
						document.body.removeChild(a) // 下载完成移除元素
					} else {
						this.$message({
							message: 'Excel下载失败失败！',
							type: 'error'
						});
					}
				})
			},
			pushPack() {
				var list = []
				var i = 0
				for (i; i < this.exportExcel.length; i++) {
					list[i] = this.exportExcel[i].userID
				}
				exportPkgByUserList({
					listData: list
				}).then((res) => {
					if (res.code == 200) {
						console.log(res)
						var baseUrl;
						baseUrl = res.data.code;
						let url = baseUrl
						const a = document.createElement('a')
						a.href = url
						// a.download = '校园招聘报名登记表.docx' 
						a.style.display = 'none'
						document.body.appendChild(a)
						a.click() // 点击下载
						document.body.removeChild(a) // 下载完成移除元素
					} else {
						this.$message({
							message: 'Excel下载失败失败！',
							type: 'error'
						});
					}
				})
			},

			// pushPDF() {
			// 	this.getPdfFromHtml(this.$refs.pdf, '123')
			// },
			cheakResume(row) {
				this.dialogPersonalResume = true
				this.cheakResumeArray = row
				this.cheakResumeArray.birthday = timestampToTime(this.cheakResumeArray.birthday)
				this.cheakResumeArray.graduationTime = timestampToTime(this.cheakResumeArray.graduationTime)
				// this.cheakResumeArray.workStartTime = timestampToTime(this.cheakResumeArray.workStartTime)
				this.imageLink = this.cheakResumeArray.imageLink
				if (this.cheakResumeArray.otherWorkContractsStatus == 1) {
					this.cheakResumeArray.otherWorkContractsStatus = this.cheakResumeArray.otherWorkContractsStatus
						.toString()
					this.cheakResumeArray.otherWorkContractsStatus = '是'
				} else if (this.cheakResumeArray.otherWorkContractsStatus == 0) {
					this.cheakResumeArray.otherWorkContractsStatus = this.cheakResumeArray.otherWorkContractsStatus
						.toString()
					this.cheakResumeArray.otherWorkContractsStatus = '否'
				}
				if (this.cheakResumeArray.workPunishmentsStatus == 1) {
					this.cheakResumeArray.workPunishmentsStatus = this.cheakResumeArray.workPunishmentsStatus.toString()
					this.cheakResumeArray.workPunishmentsStatus = '是'
				} else if (this.cheakResumeArray.workPunishmentsStatus == 0) {
					this.cheakResumeArray.workPunishmentsStatus = this.cheakResumeArray.workPunishmentsStatus.toString()
					this.cheakResumeArray.workPunishmentsStatus = '否'
				}
				if (this.cheakResumeArray.illegalRecordStatus == 1) {
					this.cheakResumeArray.illegalRecordStatus = this.cheakResumeArray.illegalRecordStatus.toString()
					this.cheakResumeArray.illegalRecordStatus = '是'
				} else if (this.cheakResumeArray.illegalRecordStatus == 0) {
					this.cheakResumeArray.illegalRecordStatus = this.cheakResumeArray.illegalRecordStatus.toString()
					this.cheakResumeArray.illegalRecordStatus = '否'
				}
				if (this.cheakResumeArray.closeRelativeStatus == 1) {
					this.cheakResumeArray.closeRelativeStatus = this.cheakResumeArray.closeRelativeStatus
						.toString()
					this.cheakResumeArray.closeRelativeStatus = '是'
				} else if (this.cheakResumeArray.closeRelativeStatus == 0) {
					this.cheakResumeArray.closeRelativeStatus = this.cheakResumeArray.closeRelativeStatus
						.toString()
					this.cheakResumeArray.closeRelativeStatus = '否'
				}
				// if (this.cheakResumeArray.freshPast == 0) {
				// 	this.cheakResumeArray.freshPast = this.cheakResumeArray.freshPast.toString()
				// 	this.cheakResumeArray.freshPast = '应届'
				// } else if (this.cheakResumeArray.freshPast == 1) {
				// 	this.cheakResumeArray.freshPast = this.cheakResumeArray.freshPast.toString()
				// 	this.cheakResumeArray.freshPast = '往届'
				// }
			},

			//下载附件压缩包
			downloadWord(row) {
				if (row.docLink == null) {
					this.$message({
						message: '该用户未上传附件！',
						type: 'error'
					});
				} else {
					var baseUrl;
					baseUrl = row.docLink
					window.open(baseUrl, '_blank')
				}
			},
			selectionChange(val) {
				this.exportExcel = val
			},
			selectResume() {
				if (this.value == '' && this.selectTime[0] == undefined && this.selectTime[1] == undefined) {
					this.$message({
						message: '请至少选择时间段，才能进行搜索！',
						type: 'error'
					});
				} else if (this.value == '' && this.selectTime[0] != undefined && this.selectTime[1] != undefined) {
					queryResumeByTime({
						endTime: this.selectTime[1],
						startTime: this.selectTime[0],
						status: this.resumeStatus,
					}).then((resByTime) => {
						if (resByTime.code == 200) {
							console.log("zjknb")
							console.log(resByTime.data)
							this.lookupresume = resByTime.data
						}
					});
				} else {
					queryResumeByPosIDAndTime({
						endTime: this.selectTime[1],
						startTime: this.selectTime[0],
						status: this.resumeStatus,
						value: this.value,
					}).then((resByPosIDAndTime) => {
						if (resByPosIDAndTime.code == 200) {
							this.lookupresume = resByPosIDAndTime.data
						}
					});
				}
			},
			addAdmingAccount(addAdmingAccount) {
				addAdminUser({
					password: addAdmingAccount.adminPassword,
					userID: addAdmingAccount.adminAccount,
				}).then((res) => {
					if (res.code == 200) {
						this.$message({
							message: '管理员账号添加成功！',
							type: 'success'
						});
						this.addControlDialog = false
					} else {
						this.$message({
							message: '管理员账号添加失败！',
							type: 'error'
						});
						this.addControlDialog = false
					}
				})
			},
			addControl() {
				this.addControlDialog = true
			},
			exit() {
				Logout().then((res) => {
					this.$router.push('/')
				})
			},
			gotolookupresumeByName() {
				this.$router.push('/management/lookUpResumeByName')
			},
			gotoadd() {
				this.$router.push('/management/addPosition')
			},
			gotoreset() {
				this.$router.push('/management/resetPosition')
			},
			// gotolookupresume(){
			// 	this.$router.push('/management/lookUpResume')
			// },
			gotorecruitInfoService() {
				this.$router.push('/management/arcticList')
			},
		},
	};

	function timestampToTime(timestamp) {
		timestamp = timestamp ? timestamp : null;
		let date = new Date(timestamp); //时间戳为10位需*1000，时间戳为13位的话不需乘1000
		let Y = date.getFullYear() + '-';
		let M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
		let D = (date.getDate() < 10 ? '0' + date.getDate() : date.getDate()) + ' ';
		return Y + M + D;
	};
</script>

<style scoped>
	@import url(../../assets/css/managementcss.css);

	.lookup_area {
		box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);
		border-radius: 4px;
		width: 80%;
		margin-left: 10%;
		margin-top: 35px;
		padding-bottom: 35px;
	}

	.lokkup_title {
		font-size: 26px;
		font-weight: bold;
		margin-left: 46.5%;
		padding-top: 25px;
	}

	.lookup_body {
		margin-top: 35px;
		width: 90%;
		padding-top: 15px;
		display: flex;
		align-items: flex-start;
		justify-content: space-between;
		height: 70px;
		margin-left: 5%;
		background-color: white;
		border-radius: 30px;
		box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);
		padding-left: 55px;
	}

	.select_position {
		margin-left: 5%;
	}

	.select_area {
		width: 250px;
	}

	.time_select {
		margin-right: 1%;
	}

	.select_button {
		margin-right: 10%;
	}

	.img_area {
		margin-left: 45%;
	}

	.resumeStatus_select {
		margin-top: 1%;
		margin-right: 1%;
	}

	.lookup_info {
		width: 90%;
		margin-left: 5%;
		padding-top: 15px;
	}

	.resumeDialogCheak {
		width: 100%;
	}

	.dialogTitle {
		margin-left: 40%;
	}

	.titleStyle {
		font-size: 24px;
	}

	.infoStyle {
		font-size: 14px;
	}

	.dialog_info {
		padding-left: 15px;
	}

	.info_area {
		margin-left: 70px;
	}

	.info_area1 {
		margin-left: 70px;
	}

	.Descriptions {
		margin-top: 35px;
		width: 100%;
		position: relative;
	}

	.push_excel {
		margin-left: 40%;
		margin-top: 35px;
	}

	.push_PDF {
		margin-left: 30%;
		margin-top: 40px;
	}

	.push_button {
		margin-left: 25px !important;
	}
</style>
